
<template>
  <ComponentFooter
    ref="footer"
    :back="backStep"
    :back_btn="back_btn_text"
    :back_disable="disable_back || back_disable"
    class="hidden-print"
    :next="nextStep"
    :next_btn=" next_btn"
    :next_disable="disable_next"
    :next_disable_tooltip="disable_tooltip">
    <template #back>
      <slot
        :back-func="backStep"
        name="back"/>
    </template>
    <template #central>
      <slot name="central"/>
    </template>
    <template #next>
      <slot
        :disable-next="disable_next"
        :disable-tooltip="disable_tooltip"
        name="next"
        :next-func="nextStep">
        <CreateTenderDialog
          v-if="publish && info.step == info.steps.length"
          :action.sync="action"
          :disabled="disable_next && disable_tooltip ? disable_tooltip : disable_next"
          :tender="tender"
          @open="disable_back = true"/>
      </slot>
    </template>
  </ComponentFooter>
</template>


<script>
import ComponentFooter from 'components/common/blocks/ComponentFooter.vue'
import CreateTenderDialog from 'components/tenders/dialogs/CreateTenderDialog.vue'

/* eslint-disable vue/prop-name-casing */
import { mapGetters } from 'vuex'
import SmarttenderApi from '@/api/smarttenderApi'
const tender_api = new SmarttenderApi()

import { modalMixin, tenderMixin } from 'mixins'
export default {
  mixins: [ tenderMixin, modalMixin ],
  name: 'createTenderFooter',
  data() {
    return {
      disable_back: false
    }
  },
  props: {
    back_btn: [Boolean, String],
    next_btn: [Boolean, String],
    next_disable: Boolean,
    back_disable: Boolean,
    next: Function,
    back: Function,
    check_disable: Function,
    createTender: Boolean,
    change: Boolean,
    publish: Boolean,
    checkChages: Function,
    validate: Function,
    valid_notification: {
      type: Boolean,
      default: true
    },
    afterCreating: Function,
    /**
  * Дату проверяем на самом 4 шаге
  */
    ignoreWrongProposalsDate: {
      type: Boolean,
      default: false
    },
    newFlou: Boolean
  },
  created() {
    if (this.wrong_proposals_date && this.info.step < (this.info.steps?.findIndex(el => el == 'TermsOfHolding') + 1)) {
      this.tender.tenderPeriodTo = null
    }
  },
  computed: {
    ...mapGetters({
      min_period_date: 'getMinPproposalsDate',
      tender: 'getNewTender',
      info: 'getNewTenderInfo'
    }),
    action: {
      get() {
        return this.publish
      },
      set(value) {
        this.$emit('update:publish', value)
      }
    },
    back_btn_text() {
      if (this.change && this.back_btn && typeof this.back_btn != 'string') {
        return this.$t('Tenders.ToAddLots')
      } else {
        return this.back_btn
      }
    },
    disable_next() {
      return !!this.next_disable || !!this.checkTender || !!this.wrong_proposals_date
    },
    disable_tooltip() {
      if (!this.min_period_date) {
        return
      }
      let result
      if (this.wrong_proposals_date) {
        const strDate = `${this.$d(new Date(this.min_period_date), 'shortDate')}, ${this.$d(new Date(this.min_period_date), 'time')}`
        result = this.$t('Validate.WrongProposalsDate' , { date: strDate })
      }
      return result
    },
    without_publication() {
      return this.tender.biddingType?.withoutPublication
    },
    wrong_proposals_date() {
      //TODO: передавать надо ли проверять через ignoreWrongProposalsDate без without_publication
      if (this.ignoreWrongProposalsDate || this.without_publication || !this.tender?.tenderPeriodTo || !this.min_period_date) { return false }
      const period = new Date(this.tender?.tenderPeriodTo).getTime()
      const min = new Date(this.min_period_date).getTime()
      return period < min

      /*
      if (this.ignoreWrongProposalsDate || this.without_publication) { return false }
      let period = this.$moment(this.$moment(this.tender?.tenderPeriodTo).format('YYYY-MM-DDTHH:mm')).format('x'),
        min = this.$moment(this.$moment(this.min_period_date).format('YYYY-MM-DDTHH:mm')).format('x')
      return this.min_period_date && this.tender?.tenderPeriodTo && period < min
      */
    },
    checkTender() {
      if (this.app) { return }
      if (this.without_publication) { return false }
      let result
      if (!this.tender.tenderPeriodTo && !this.tender.tenderPeriod?.endDate
   && this.info.step > (this.info.steps?.findIndex(el => el == 'TermsOfHolding') + 1)) {
        result = true
      }
      return result
    }
  },
  methods: {
    async nextStep() {
      if (this.validate && typeof this.validate === 'function') {
        await this.validate().then(async (result) => {
          if (result) {
            await this.chngeSteps(true)
          } else if (this.valid_notification) {
            this.$notice.info({
              title: this.$t('Common.PleaseNote'),
              message: this.$t('Validate.checkRequiredFelds'),
              showClose: true,
              progress: true,
              duration: 10
            })
          }
        })
      } else {
        await this.chngeSteps(true)
      }
    },
    async backStep() {
      if (this.checkChages && this.checkChages()) {
        this.$root.$emit('showExitConfirmation', { submitExit: this.chngeSteps })
      } else {
        await this.chngeSteps(false)
      }
      this.$emit('backStep')
    },
    /*async changeToAuction() {
      if (this.info?.steps.length == 2) {
        this.$store.commit('setNewTenderInfo', { ...this.info, step: 2 })
      }
    },*/
    async checkValidEditing(er) {

      let org = this.$route.params.org,
        flou = this.$route.params.orfloug,
        tenderId = this.tender.tenderId,
        toTender = () => {
          this.$router.push({name: 'tenderitem', params: { id: tenderId, org, flou }})
        }

      if (this.has_required_agreement && !this.has_required_agreement.onStart) {
        let agreement
        await this.$store.dispatch('tendersAgreements', [+tenderId])
          .then(res => {
            if (res?.length) {
              agreement = res[0] // todo additional agreement
            }
          })
        if (agreement?.agreements?.length && !agreement?.agreements?.find(el => el.isMy)?.editWhileAgree) {
          this.$Modal.info({
            title: this.$t('Tenders.YouCantEditTender'),
            content: this.$t('Tenders.TenderIsOnAcceptin'),
            closable: false,
            okText: this.$t('Tenders.ToTender'),
            onOk: toTender,
            width: 736
          })
        }
      } else {
        let updated = await tender_api.tenderStatusAndSchedule(tenderId),
          confirm = async () => {
            await tender_api.returnToRegistration(tenderId)
              .then(async res => {
                if (res.data.returnToRegistration) {
                  await this.$store.dispatch('getEditingTender', tenderId)
                  this.$Modal.remove()
                } else {
                  toTender()
                }
              })
          }
        if (updated?.tenderPublishedSchedule?.isScheduled || updated?.tenderStatus?.id > 1) {
          this.$Modal.confirm({
            title: this.$t('Tenders.SureToEdit'),
            content: this.$t('Tenders.SureToReturnToRegistration', {
              status: this.getStatus(updated)?.title,
              restart: updated?.tenderPublishedSchedule?.isScheduled
                ? this.smallFirstLetter(this.$t('Tenders.ToSchedule'))
                : this.$t('Tenders.Republish')
            }),
            closable: false,
            okText: this.$t('Tenders.ReturnAndEdit'),
            cancelText: this.$t('Common.Cancel'),
            loading: true,
            onOk: confirm,
            onCancel: toTender,
            width: 736
          })
        }
      }

      if (JSON.stringify(er.graphQLErrors).includes('Has duplicated Title and MeasuringUnit')) {
        er = this.$t('Validate.DublicateLotNameAndUnit')
      }
      throw er
    },
    async chngeSteps(mode) {
      this.$root.$emit('showOverlay')

      this.$_minTenderPeriodDate()
      try {
        if (mode && this.next) {
          await this.next()
        } else if (!mode && this.back) {
          await this.back()
        }
      } catch (error) {
        this.$log_error(error)
        this.$root.$emit('closeOverlay')
        return
      }

      if (mode) {
        try {
          if (this.check_disable) {
            this.check_disable()
          }

          if (this.wrong_proposals_date && !this.publish && this.info?.step != 1) {
            const strDate = `${this.$d(new Date(this.min_period_date), 'shortDate')}, ${this.$d(new Date(this.min_period_date), 'time')}`
            throw this.$t('Validate.WrongProposalsDate' , {date: strDate})
          }
          if (this.publish) {
            //await this.changeToAuction()
            this.$root.$emit('closeOverlay')
            return
          }
          let changed = !this.checkChages || this.checkChages()

          this.$store.commit('setNewTenderInfo', {...this.info, loading: true })
          if (this.createTender && !this.tender.tenderId) {
            await tender_api.createTender(this.tender, this.$store.getters['getNewTenderInfo']?.mode == 'plan').finally(() => this.$root.$emit('closeOverlay'))

          } else if (this.tender.tenderId && changed) {
            this.checkTenderBySettings(this.tender)
            if (this.$_initializeLotGroups) {
              this.$_initializeLotGroups(this.tender)
            }
            await tender_api.editTenderDraft(this.tender)
              .then((res) => {
                if (!res) {
                  this.$show_error_message(this.$t('Errors.TryAgain'))
                  this.$log_error('editTenderDraft повернув null')
                  this.$root.$emit('closeOverlay')
                  this.$store.commit('setNewTenderInfo', { step: 0 })
                  return
                } else {
                  this.$store.commit('setNewTender', res)
                }
              })
              .catch(this.checkValidEditing)
              .finally(() => this.$root.$emit('closeOverlay'))
          }

          if (this.afterCreating) {
            await this.afterCreating()
          }
          this.$store.commit('setNewTenderInfo', {...this.info, default: this.$_.cloneDeep(this.tender), loading: false })

        } catch (error) {
          this.$emit('update:publish', false)
          this.$show_error_message(error)
          this.$log_error(error)
          this.$root.$emit('closeOverlay')
          return
        }
      }
      this.$root.$emit('closeOverlay')
      if (this.publish) {
        if (this.info?.step == 1) {
          this.$emit('update:publish', false)
        } else if (this.info?.step == 2) {
          this.$store.commit('setNewTenderInfo', { ...this.info, step: 1 })
        } else if (this.info?.step == 3) {
          this.$store.commit('setNewTenderInfo', { ...this.info, step: 2 })
        }
        return
      }
      this.$notice.closeAll()
      this.$emit(mode ? 'nextStep' : 'backStep')
      if (!this.newFlou) {
        this.changeStep(mode)
      }
    }
  },
  components: {
    ComponentFooter,
    CreateTenderDialog
  }
}
</script>
